import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import PuppyDetail from "./pages/PuppyDetail";
import Adopted from "./pages/Adopted";
import Litters from "./pages/Litters";
import Reviews from "./pages/Reviews";
import Shipping from "./pages/Shipping";
import Care from "./pages/Care";
import Contact from "./pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/puppies" element={<Shop />} />
          <Route path="/puppy/:id" element={<PuppyDetail />} />
          <Route path="/adopted" element={<Adopted />} />
          <Route path="/litters" element={<Litters />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/care" element={<Care />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
